import { lazyLoad } from 'utils/loadable';

export const TermsOfUseAgreementPage = lazyLoad(
  () => import('./index'),
  module => module.TermsOfUseAgreementPage,
);
